import { PatientVerificationFormField } from './subsections/patient-verification/formField'
import { HistoryAndDiagnosesFormField } from './subsections/history-and-diagnoses/formField'

export const PatientBackgroundFormField = {
  ...PatientVerificationFormField,
  ...HistoryAndDiagnosesFormField
} as const

export type PatientBackgroundFormField =
  (typeof PatientBackgroundFormField)[keyof typeof PatientBackgroundFormField]
